export default {
    CABINET: 'cabinet',
    CATEGORY: 'category',
    LANGUAGE: 'i18nextLng',
    LOCAL_LANGUAGE: 'i18nextLng2',
};
